// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__GgAQm","infoBtn":"quickbooks_infoBtn__1i-Mb","formBox":"quickbooks_formBox__3izwG","formFooter":"quickbooks_formFooter__2zsVt"};